import { IHealthySoilsAssessment } from "../../../hsa/types"
import { DatalayerZone, DrawingLayer, FieldViewModel, IGeometry, isObject, MapGeometryType } from "../../../omnia"
import { IDataLayer, IDataLayerType, IDataLayerZone, LayerTypeId } from "../../../types"
import { IViewerContext } from "../types"

export class HsaLayer extends DrawingLayer {


    public static createVirtualLayers(ctxt: IViewerContext, hsa: IHealthySoilsAssessment[]) {

        if (!hsa) {
            return null;
        }

        let layerType = ctxt.soilSvc.getLayerType(LayerTypeId.Drawing)

        return ctxt.soilSvc.fields.map(f => {

            let subset = hsa.filter(h =>
                h.Location
                && h.Allocations
                && h.Allocations.some(a => a.FieldId == f.fieldId));

            if (subset.length) {

                let datalayer = HsaLayer.createLayer(subset, layerType, f);

                let instance = new HsaLayer(datalayer, ctxt.datalayerContext)

                let options = {
                    layerInstance: instance,
                };

                let layerVm = ctxt.createLayerViewModel(datalayer, f, options)

                layerVm.selectable = true;
                layerVm.showTooltips = false;

                return layerVm;

            }

        }).filter(l => !!l);

    }

    private static createLayer(hsa: IHealthySoilsAssessment[], layerType: IDataLayerType, field: FieldViewModel) {

        let zones: IDataLayerZone[] = hsa.map((h, index) => {

            return {
                DataLayerZoneId: h.HealthySoilsAssessmentId,
                Number: index + 1,
                Geometry: <IGeometry>(isObject(h.Location) ? h.Location : <IGeometry>{
                    Geometry: {
                        WellKnownText: h.Location,
                        CoordinateSystemId: 3857,
                    }
                }),
                Value: null,
                Name: h.AnalysisNumber,
                Data: h,
            }

        });

        let layer: IDataLayer = {
            DataLayerId: 0,
            FieldId: field.fieldId,
            GeometryType: MapGeometryType.Point,
            TypeId: layerType.TypeId,
            Type: layerType,
            Zones: zones
        }

        return layer;

    }

    protected getTextStyles(zone: DatalayerZone, resolution: number, offsetY: number) {
        return [];
    }

}
